import axiosInstance from "../axios_instance";

export async function singleFileUpload(body) {
  try {
    return await axiosInstance.post(`file/upload-single`, body);
  } catch (error) {
    return error;
  }
}

export async function fileDownload(body) {
  try {
    return await axiosInstance.post(`file/download`, body);
  } catch (error) {
    return error;
  }
}

export async function fileDelete(fileName) {
  try {
    return await axiosInstance.delete(`file/${fileName}`);
  } catch (error) {
    return error;
  }
}
